export default __webpack_public_path__ + "static/media/partner-4-wasted-lands.6a93daed.jpeg";